(() => {
  const storageKey = 'mulinB2BSelections';
  const csvValue = (value) => `"${String(value ?? '').replace(/"/g, '""')}"`;

  const loadStore = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(storageKey) || '{}');
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (_error) {
      return {};
    }
  };

  const saveStore = (store) => {
    localStorage.setItem(storageKey, JSON.stringify(store));
  };

  const getItemRow = (item) => {
    const qtyInput = item.querySelector('[data-b2b-export-qty]');
    const quantity = Math.max(1, parseInt(qtyInput?.value || '1', 10) || 1);
    return {
      productName: item.dataset.productTitle || '',
      sku: item.dataset.productSku || '',
      quantity,
      variantId: item.dataset.variantId || '',
      productUrl: item.dataset.productUrl || '',
      exportPrices: item.dataset.exportPrices === 'true',
      priceCents: parseInt(item.dataset.productPriceCents || '0', 10) || 0,
      compareCents: parseInt(item.dataset.productCompareCents || '0', 10) || 0,
      currency: item.dataset.productCurrency || ''
    };
  };

  const getStoredRows = () => Object.values(loadStore()).filter((row) => row && row.variantId);

  const getScopeRows = (scope, items) => {
    if (scope.hasAttribute('data-b2b-selection-page')) {
      return getStoredRows();
    }

    return items
      .filter((item) => item.querySelector('[data-b2b-export-check]')?.checked)
      .map(getItemRow);
  };

  const exportRows = (scope, rows) => {
    if (!rows.length) return;

    const includePrices = rows.some((row) => row.exportPrices);
    const header = includePrices
      ? ['Product name', 'SKU', 'Quantity', 'Unit price', 'Total price', 'Compare at price', 'Currency', 'Variant ID', 'Product URL']
      : ['Product name', 'SKU', 'Quantity', 'Variant ID', 'Product URL'];

    const body = rows.map((row) => (
      includePrices
        ? [
            row.productName,
            row.sku,
            row.quantity,
            (row.priceCents / 100).toFixed(2),
            ((row.priceCents * row.quantity) / 100).toFixed(2),
            row.compareCents > 0 ? (row.compareCents / 100).toFixed(2) : '',
            row.currency,
            row.variantId,
            row.productUrl
          ]
        : [
            row.productName,
            row.sku,
            row.quantity,
            row.variantId,
            row.productUrl
          ]
    ));

    const csv = [header, ...body].map((row) => row.map(csvValue).join(';')).join('\r\n');
    const blob = new Blob(['\ufeff', csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    const date = new Date().toISOString().slice(0, 10);
    const name = scope.dataset.b2bExportName || 'mulin-b2b-richiesta';
    link.href = url;
    link.download = `${name}-${date}.csv`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  };

  const renderSelectionPage = (scope) => {
    const list = scope.querySelector('[data-b2b-selection-list]');
    const empty = scope.querySelector('[data-b2b-selection-empty]');
    if (!list) return;

    const rows = getStoredRows();
    list.innerHTML = '';
    if (empty) empty.hidden = rows.length > 0;

    rows.forEach((row) => {
      const item = document.createElement('article');
      item.className = 'b2b-selection-item';
      item.setAttribute('data-b2b-export-item', '');
      item.dataset.productTitle = row.productName || '';
      item.dataset.productSku = row.sku || '';
      item.dataset.variantId = row.variantId || '';
      item.dataset.productUrl = row.productUrl || '';
      if (row.exportPrices) {
        item.dataset.exportPrices = 'true';
        item.dataset.productPriceCents = String(row.priceCents || 0);
        item.dataset.productCompareCents = String(row.compareCents || 0);
        item.dataset.productCurrency = row.currency || '';
      }

      const price = row.exportPrices
        ? `<div class="b2b-export-price"><span>Prezzo export</span><strong>${(row.priceCents / 100).toFixed(2)} ${row.currency || ''}</strong></div>`
        : '';

      item.innerHTML = `
        <div class="b2b-selection-item__main">
          <a href="${row.productUrl || '#'}">${row.productName || ''}</a>
          <span>SKU: ${row.sku || '-'}</span>
        </div>
        <div class="b2b-export-controls">
          <label class="b2b-export-check">
            <input type="checkbox" checked data-b2b-export-check>
            <span>Seleziona</span>
          </label>
          <label class="b2b-export-qty">
            <span>Qta</span>
            <input type="number" min="1" step="1" value="${row.quantity || 1}" inputmode="numeric" data-b2b-export-qty>
          </label>
        </div>
        ${price}
        <button type="button" class="button button--secondary b2b-selection-item__remove" data-b2b-selection-remove>Rimuovi</button>
      `;

      list.appendChild(item);
    });
  };

  const initScope = (scope) => {
    if (scope.hasAttribute('data-b2b-selection-page')) {
      renderSelectionPage(scope);
    }

    const items = Array.from(scope.querySelectorAll('[data-b2b-export-item]'));
    const countEl = scope.querySelector('[data-b2b-export-count]');
    const exportButton = scope.querySelector('[data-b2b-export-button]');
    const clearButton = scope.querySelector('[data-b2b-export-clear]');
    if (!items.length || !exportButton || exportButton.dataset.b2bExportReady === 'true') return;

    exportButton.dataset.b2bExportReady = 'true';

    const hydrateFromStore = () => {
      const store = loadStore();
      items.forEach((item) => {
        const saved = store[item.dataset.variantId || ''];
        const checkbox = item.querySelector('[data-b2b-export-check]');
        const qty = item.querySelector('[data-b2b-export-qty]');
        if (saved && checkbox) checkbox.checked = true;
        if (saved && qty) qty.value = saved.quantity || 1;
      });
    };

    const updateCount = () => {
      const rows = getScopeRows(scope, items);
      if (countEl) {
        countEl.textContent = rows.length === 1 ? '1 prodotto selezionato' : `${rows.length} prodotti selezionati`;
      }
      exportButton.disabled = rows.length === 0;
    };

    const syncItem = (item) => {
      const checkbox = item.querySelector('[data-b2b-export-check]');
      const key = item.dataset.variantId || '';
      if (!key) return;

      const store = loadStore();
      if (checkbox?.checked) {
        store[key] = getItemRow(item);
      } else {
        delete store[key];
      }
      saveStore(store);
      updateCount();
    };

    hydrateFromStore();

    items.forEach((item) => {
      item.querySelector('[data-b2b-export-check]')?.addEventListener('change', () => {
        syncItem(item);
        if (scope.hasAttribute('data-b2b-selection-page')) {
          renderSelectionPage(scope);
          initScope(scope);
        }
      });
      item.querySelector('[data-b2b-export-qty]')?.addEventListener('input', () => syncItem(item));
      item.querySelector('[data-b2b-selection-remove]')?.addEventListener('click', () => {
        const store = loadStore();
        delete store[item.dataset.variantId || ''];
        saveStore(store);
        renderSelectionPage(scope);
        initScope(scope);
      });
    });

    clearButton?.addEventListener('click', () => {
      if (scope.hasAttribute('data-b2b-selection-page')) {
        saveStore({});
        renderSelectionPage(scope);
        initScope(scope);
        updateCount();
        return;
      }

      const store = loadStore();
      items.forEach((item) => {
        const checkbox = item.querySelector('[data-b2b-export-check]');
        const qty = item.querySelector('[data-b2b-export-qty]');
        if (checkbox) checkbox.checked = false;
        if (qty) qty.value = '1';
        delete store[item.dataset.variantId || ''];
      });
      saveStore(store);
      updateCount();
    });

    exportButton.addEventListener('click', () => exportRows(scope, getScopeRows(scope, items)));
    updateCount();
  };

  const init = () => {
    document.querySelectorAll('[data-b2b-export-scope]').forEach(initScope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
